import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 0,
  refreshToken: null,
  accessToken: null,
  isAuthenticated:false
  
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      localStorage.setItem("refreshToken", JSON.stringify(action.payload));
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      state.isAuthenticated=true;
      localStorage.setItem("accessToken", JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
       state.isAuthenticated = false;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  setRefreshToken,
  setAccessToken,
  logout,
} = counterSlice.actions;

export default counterSlice.reducer;
